import React from 'react';
import { MarketSvgProps } from '../market-icons';

const CopyIcon: React.FC<MarketSvgProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 15C28.2652 15 28.5195 15.1054 28.707 15.293C28.8946 15.4805 29 15.7348 29 16V29C29 29.5523 28.5523 30 28 30H17C16.4477 30 16 29.5523 16 29V16L16.0049 15.8975C16.0562 15.3933 16.4823 15 17 15H28ZM18 28H27V17H18V28Z"
        fill="#101010"
      />
      <path
        d="M24 12H13V25H11V11C11 10.7348 11.1054 10.4805 11.293 10.293C11.4805 10.1054 11.7348 10 12 10H24V12Z"
        fill="#101010"
      />
    </svg>
  );
};

export default CopyIcon;
